<template>

<!-- 弹出 Popup -->
<div class="dialog">
    <div class="dialog__trigger" >
        <!-- 插槽 显示的内容，点击@click="open"这会显示dialog -->
        <slot name="trigger"></slot>
    </div>

    <el-dialog
        :z-index="1000"
        :visible.sync="visible"
        :custom-class="customClass"
        :center="center"
        :append-to-body="true"
        :width="width"
        :close-on-click-modal="clickModalClose"
        @closed="close"
        append-to-body
    >
        <!-- 弹窗内容 -->

        <!-- 1-dialog 的头信息 -->
        <template v-if="title" #title>{{ title }}</template>
        
        <!-- 2-自定义内容 （默认插槽）-->
        <slot>{{ content }}</slot>
        
        <!-- 3-底部弹窗页脚 -->
        <template #footer>
            <div class="dialog-footer">
                <el-button v-if="cancelButtonText" @click="handleEvent('cancel')">
                    {{ cancelButtonText }}
                </el-button>
                <el-button
                    v-if="confirmButtonText"
                    type="primary"
                    @click="handleEvent('confirm')"
                >
                    {{ confirmButtonText }}
                </el-button>
            </div>
        </template>
    </el-dialog>
</div>   
</template>

<script>
export default {
    name:'PopUp',
    props: {
        title: {
            // 弹窗标题
            type: String,
            default: ''
        },
        content: {
            // 弹窗内容
            type: String,
            default: ''
        },
        confirmButtonText: {
            // 确认按钮内容
            type: [String, Boolean],
            default: '确定'
        },
        cancelButtonText: {
            // 取消按钮内容
            type: [String, Boolean],
            default: '取消'
        },
        width: {
            // 弹窗的宽度
            type: String,
            default: '400px'
        },
        disabled: {
            // 是否禁用
            type: Boolean,
            default: true
        },
        async: {
            // 是否开启异步关闭
            type: Boolean,
            default: false
        },

        clickModalClose: {
            // 点击遮罩层关闭对话窗口
            type: Boolean,
            default: false
        },
        center: {
            // 是否居中布局
            type: Boolean,
            default: false
        },
        customClass: {
            //自定义样式
            type: String,
            default: ''
        }
    },

    data(){
        return {
            visible:false,
        }
    },
    methods:{
        //
        handleEvent(type){
            this.$emit(type);
            
            if (!this.async || type === 'cancel') {
                this.close();
            }
        },
        // 打开
        open(){
            if (this.disabled) {
                return
            }
            this.$emit('open')//
            this.visible= true;
        },
        
        // 关闭
        close(){
            this.visible=false;
            this.$nextTick(()=>{
                //可以在组件中使用 v-on:close了 
                this.$emit('close')
            });
        }
    }
}
</script>